import React, { useState } from 'react';
import { Box } from '@withjoy/joykit';

/** The id the "Filters" toggle names in `aria-controls`. */
export const COLLAPSIBLE_FILTERS_PANEL_ID = 'accommodations-console-collapsible-filters-panel';

type CollapsibleFiltersPanelProps = Readonly<{
  /** Owned by the console, whose listings' title row draws the toggle. */
  isOpen: boolean;
  children: React.ReactNode;
}>;

/**
 * The desktop filter panel behind the "Filters" toggle. The panel starts collapsed.
 *
 * - The panel mounts on the first expand, so its one-time "available only" tooltip opens when the host
 *   first sees the panel, not while it is hidden.
 * - After that, a collapse hides the panel and keeps it mounted, so the tooltip does not open again and
 *   state inside the panel is not reset.
 */
export const CollapsibleFiltersPanel = ({ isOpen, children }: CollapsibleFiltersPanelProps) => {
  const [hasPanelBeenOpened, setHasPanelBeenOpened] = useState(isOpen);
  if (isOpen && !hasPanelBeenOpened) {
    setHasPanelBeenOpened(true);
  }

  return (
    <Box
      id={COLLAPSIBLE_FILTERS_PANEL_ID}
      display={isOpen ? 'flex' : 'none'}
      flexShrink={0}
      height="100%"
      minHeight={0}
    >
      {hasPanelBeenOpened && children}
    </Box>
  );
};
